import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "hidden flex-1 sm:block" }
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-gray-700"
}
const _hoisted_3 = {
  key: 1,
  class: "text-sm text-gray-700"
}
const _hoisted_4 = {
  class: "inline-flex -space-x-px rounded shadow",
  "aria-label": "Pagination"
}
const _hoisted_5 = ["onClick"]

import { computed } from 'vue';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/vue/solid';


export default /*@__PURE__*/_defineComponent({
  __name: 'UiPagination',
  props: {
    modelValue: {
        type: Number,
        required: true,
    },
    count: {
        type: Number,
        required: true,
    },
    perPage: {
        type: Number,
        required: true,
    },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;

const pageCount = computed(() => {
    return Math.ceil(props.count / props.perPage);
});

const pages = computed(() => {
    const response: number[] = [];
    const current = props.modelValue;

    let start = current - 2 <= 0 ? 1 : current - 2;
    let end = current + 2 < pageCount.value ? current + 2 : pageCount.value;

    const diff = end - start;
    if (diff < 4 && end + (4 - diff) < pageCount.value) {
        end = end + (4 - diff);
    } else if (diff < 4 && start - (4 - diff) > 0) {
        start = start - (4 - diff);
    }

    for (let i = start; i <= end; i++) {
        response.push(i);
    }

    return response;
});

const paginationLabelData = computed(() => {
    let start = 1;
    let end = props.modelValue * props.perPage;
    const total = props.count;

    if (props.modelValue >= 1) start = props.modelValue * props.perPage - props.perPage + 1;

    if (props.modelValue == pageCount.value) end = props.count;

    return {
        start,
        end,
        total,
    };
});

const emit = __emit;
function goTo(page: number) {
    if (props.modelValue !== page) {
        emit('update:modelValue', page);
    }
}

return (_ctx: any,_cache: any) => {
  const _component_UiPanel = _resolveComponent("UiPanel")!

  return (_openBlock(), _createBlock(_component_UiPanel, {
    class: "flex items-center justify-center px-4 py-2",
    "no-padding": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.count > 1)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t('pagination.label', paginationLabelData.value)), 1))
          : _createCommentVNode("", true),
        (__props.count === 1)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t('pagination.labelOnePage', {
                        total: __props.count,
                    })), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("nav", _hoisted_4, [
          (props.modelValue > 1)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (goTo(props.modelValue - 1))),
                class: "relative inline-flex cursor-pointer items-center rounded-l-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50"
              }, [
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "sr-only" }, "Previous", -1)),
                _createVNode(_unref(ChevronLeftIcon), {
                  class: "h-5 w-5",
                  "aria-hidden": "true"
                })
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pages.value, (page) => {
            return (_openBlock(), _createElementBlock("span", {
              key: `page${page}`,
              onClick: ($event: any) => (goTo(page)),
              "aria-current": "page",
              class: _normalizeClass(["relative inline-flex items-center border bg-white px-4 py-2 text-sm font-medium", 
                            page === props.modelValue
                                ? 'theme-border-color theme-color z-3'
                                : 'z-2 cursor-pointer border-gray-300 text-gray-500 hover:bg-gray-50'
                        ])
            }, _toDisplayString(page), 11, _hoisted_5))
          }), 128)),
          (props.modelValue < pageCount.value)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (goTo(props.modelValue + 1))),
                class: "relative inline-flex cursor-pointer items-center rounded-r-md border border-gray-300 bg-gray-50 px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50"
              }, [
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "sr-only" }, "Next", -1)),
                _createVNode(_unref(ChevronRightIcon), {
                  class: "h-5 w-5",
                  "aria-hidden": "true"
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})